<script setup lang="ts">
import { useMounted } from "@vueuse/core";
import VLoader from "./VLoader.vue";

interface IBlockLoaderProps {
  absolute?: boolean;
  page?: boolean;
  show?: boolean;
  overlay?: boolean;
  onlyOverlay?: boolean;
  size?: "xxs" | "xs" | "s" | "m" | "l";
  title?: string;
  color?: "primary" | "invert" | "project" | "inherit";
}

withDefaults(defineProps<IBlockLoaderProps>(), {
  size: "l",
  title: "Загрузка...",
  color: "primary",
});
defineOptions({ inheritAttrs: false });

// В SSR приложениях этот компонент вызывал хитрые ошибки, поэтому мы его таким образом рисуем только на клиентской части.
// (teleport не очень дружит с SSR например, даже не смотря на то, что телепорт не активен)
const isMounted = useMounted();
</script>

<template>
  <div class="block-loader-wrapper">
    <teleport v-if="isMounted" to="body" :disabled="!page">
      <transition name="fade">
        <div
          v-if="show"
          v-bind="$attrs"
          class="block-loader"
          :class="{
            'block-loader_absolute': absolute,
            'block-loader_fixed': page,
            'block-loader_overlay': overlay || page || onlyOverlay,
          }"
        >
          <div v-if="!onlyOverlay">
            <VLoader :color="color" :title="title" :size="size" />
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<style scoped lang="postcss">
.block-loader {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: calc(var(--pl-z-index-toast) + 1);

  &_absolute {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  &_fixed {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
  }

  &_overlay {
    background: var(--pl-overlay-background-loading);
  }

  &__content {
    margin-top: 30px;
    font: var(--pl-font-body-large-regular);
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
